module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site",
    attrs: {
      "id": "app"
    }
  }, [_c('main', {
    staticClass: "site-content"
  }, [_c('header', [_c('navbar')], 1), _vm._v(" "), (_vm.showHeader) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container content-wrapper"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a4671ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a4671ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 152
// module chunks = 1